// src/config/contact.js
// ─── Source unique pour tous les liens de contact ───
// Modifie ici, ça se répercute partout (footer, modal, etc.)

const contact = {
  email: "akromanjeff8@gmail.com",
  whatsapp: "https://wa.me/+2250141819144",
  telegram: "https://t.me/jeffakroman",
  linkedin: "https://linkedin.com/in/jeff-akroman", 
  github: "https://github.com/Kylan88",
  cv: "/cv.pdf",
};

export default contact;